import moment = require("moment");

export default function compareDate(dateTimeA:string, dateTimeB:string) {

    if (dateTimeA===null || dateTimeB===null) return 1;

    let momentA = moment(dateTimeA);
    let momentB = moment(dateTimeB);
    if (momentA > momentB) return 1;
    else if (momentA < momentB) return -1;
    else return 0;
}
